import { label, primary, secondary } from 'styles'

import { makeStyles } from '@mui/styles'

export default makeStyles({
  accordion: {
    '&&&': {
      borderBottom: `1px solid ${label}`,
      borderTopLeftRadius: '0',
      borderTopRightRadius: '0',
      boxShadow: 'none',
    },
    '&:first-child > div:first-child': {
      paddingRight: '0.5rem',
    },
  },
  accordionDetails: {
    '&&': {
      backgroundColor: '#F5F7F8',
      borderTop: `1px solid ${label}`,
      padding: '0',
    },
  },
  accordionSummaryContent: {
    '&&': {
      margin: '0',
    },
  },
  accordionSummaryExpanded: {
    '&&&': {
      margin: '0',
    },
  },
  accordionSummaryRoot: {
    '&&&': {
      color: secondary,
      fontWeight: '600',
      minHeight: '2.5rem',
    },
  },
  expandedIcon: {
    color: primary,
  },
})
